import { useState, useEffect } from 'react';
import { useBreakpoint } from './useBreakpoint';

export const useMenuState = () => {
  const { isMobile, isTablet } = useBreakpoint();
  
  // 侧边栏是否折叠
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });

  // 移动端菜单是否显示
  const [mobileMenuVisible, setMobileMenuVisible] = useState(false);

  // 当前选中的菜单项
  const [selectedKeys, setSelectedKeys] = useState([]);

  // 展开的子菜单
  const [openKeys, setOpenKeys] = useState(() => {
    const saved = localStorage.getItem('menuOpenKeys');
    return saved ? JSON.parse(saved) : [];
  });

  // 保存侧边栏状态到本地存储
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(sidebarCollapsed));
  }, [sidebarCollapsed]);

  // 保存展开的菜单项到本地存储
  useEffect(() => {
    localStorage.setItem('menuOpenKeys', JSON.stringify(openKeys));
  }, [openKeys]);

  // 响应式处理：移动端和平板自动折叠侧边栏
  useEffect(() => {
    if (isMobile || isTablet) {
      setSidebarCollapsed(true);
      setMobileMenuVisible(false);
    }
  }, [isMobile, isTablet]);

  // 切换侧边栏折叠状态
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // 切换移动端菜单显示状态
  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
  };

  // 关闭移动端菜单
  const closeMobileMenu = () => {
    setMobileMenuVisible(false);
  };

  // 处理菜单项选择
  const handleMenuSelect = (keys) => {
    setSelectedKeys(keys);
    // 移动端选择菜单项后自动关闭菜单
    if (isMobile) {
      setMobileMenuVisible(false);
    }
  };

  // 处理子菜单展开
  const handleSubMenuOpen = (keys) => {
    setOpenKeys(keys);
  };

  return {
    sidebarCollapsed,
    mobileMenuVisible,
    selectedKeys,
    openKeys,
    toggleSidebar,
    toggleMobileMenu,
    closeMobileMenu,
    handleMenuSelect,
    handleSubMenuOpen,
    setSelectedKeys,
    setOpenKeys
  };
};